const { snakeCase } = require('lodash');

const queryHelper = {
	emptyListResponse: () => {
		return {
			list: [],
			totalCount: 0,
		};
	},
	errors: error => {
		return [{
			extensions: {
				exception: error,
			},
			message: error.message,
		}];
	},
	getCriteriaVariablesRelay: sortOptions => {
		return {
			limit: sortOptions.rowsPerPage,
			offset: sortOptions.page * sortOptions.rowsPerPage,
			sortDirection: sortOptions.order === 'desc' ? 'DESC' : 'ASC',
		};
	},
	relayToListResponse: response => {
		if (!response) {
			return queryHelper.emptyListResponse();
		}

		const totalCount = response.totalCount;
		let list = [];
		if (response.edges) {
			list = response.edges.map((n) => n.node);
		}

		return {
			list,
			totalCount,
		};
	},
	response: response => {
		if (!response || (!response.data && !response.errors)) {
			throw new Error('No response returned from server.');
		}
		return response;
	},
};

module.exports = queryHelper;
